import React from 'react';
import { Row, Col } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAddressCard, faUserCheck, faUserTimes } from '@fortawesome/free-solid-svg-icons'

export default function IdentityButton(props) {
  
  let isVerified = props.isVerified;

  let textColor = '#fff';
  let textValue = isVerified ? 'Identity\nVerified' : 'Verify\nIdentity';
  let bgColor = isVerified ? '#73B233' : '#BD9806';
  let fontSize = 20, textSize = 12;
  let fontIcon = isVerified ? faUserCheck : faUserTimes;

  return (
    <Row className='identityRow' onClick={() => {props.openIdentityPopup()}} 
      style={{ width: 170, background: bgColor, marginLeft: 15, height: 44, cursor: 'pointer' }}>
        <Col style={{ display: 'flex', alignItems:'center', justifyContent: 'center' }} span={7}>
            <FontAwesomeIcon icon={faAddressCard} style={{ color: textColor, fontSize: fontSize }} />
        </Col>
        <Col style={{ display: 'flex', justifyContent: 'center', alignItems:'center', whiteSpace: 'break-spaces',
            fontSize: textSize, lineHeight: 1.3, fontFamily: 'OpenSans-Bold', color: textColor }} span={10}>
            {textValue}
        </Col>
        <Col style={{ display: 'flex', alignItems:'center', justifyContent: 'center' }} span={7}>
            <FontAwesomeIcon icon={fontIcon} style={{ color: textColor, fontSize: fontSize }} />
        </Col>
    </Row>
  );
}
